/**
 * Ruta /admin/home/semantic-models/modelos/:modelId/graph -- diagrama de un
 * modelo semántico (ver SemanticModelDiagram), con el encabezado de las
 * páginas del admin y la vuelta a la lista conservando el modelo elegido.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { PageContainer } from '../../admin/home/components/AdminContentWrapper';
import SemanticModelService from '../../services/SemanticModelService';
import SemanticModelDiagram from './SemanticModelDiagram';

const GraphPageWrapper = () => {
  const { modelId } = useParams();
  const navigate = useNavigate();
  const [modelName, setModelName] = useState('');

  useEffect(() => {
    let cancelled = false;
    SemanticModelService.getById(modelId)
      .then((response) => {
        const model = response?.data && !Array.isArray(response.data) ? response.data : response;
        if (!cancelled) setModelName(model?.name || '');
      })
      .catch(() => {
        // El diagrama muestra su propio error; el título queda genérico.
      });
    return () => {
      cancelled = true;
    };
  }, [modelId]);

  const handleBackToList = () => {
    const searchParams = new URLSearchParams({ view: 'list', modelId });
    navigate(`/admin/home/semantic-models/modelos?${searchParams.toString()}`);
  };

  return (
    <PageContainer
      title={modelName ? `Diagrama: ${modelName}` : 'Diagrama del modelo'}
      description="Tablas del modelo semántico y las relaciones (joins) entre ellas. Haz clic en una tabla o en una relación para ver su detalle."
      headerSpacing={2}
      actions={[
        <Button
          key="back"
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={handleBackToList}
          sx={{ textTransform: 'none', borderColor: 'var(--wb-accent-40)', color: 'var(--wb-accent)' }}
        >
          Volver a modelos
        </Button>
      ]}
    >
      <Box
        sx={{
          height: { xs: 'calc(100vh - 260px)', md: 'calc(100vh - 220px)' },
          minHeight: 420,
          borderRadius: 2,
          overflow: 'hidden',
          border: '1px solid var(--wb-border)',
          boxShadow: '0 12px 32px var(--wb-x-shadow-0f172a59, rgba(15, 23, 42, 0.35))'
        }}
      >
        <SemanticModelDiagram modelId={modelId} />
      </Box>
    </PageContainer>
  );
};

export default GraphPageWrapper;
